import BlockyBoldText from "components/custom-texts/blocky-bold-text";
import { Modal } from "react-bootstrap";
import { PoolDetailsResponse } from "interfaces/pool-details-response.ts";
import { getCardColor } from "state/slices/group-slice";
import { useAppSelector } from "state/hooks";
import { textColor } from "utils/constants.ts";
import dateFormatter from "utils/formatter-utils/date-formatter.ts";
import BlockyMediumText from "components/custom-texts/blocky-medium-text.tsx";
import styles from "components/pool-details/rules-modal/styles.module.css";
import React from "react";

interface RulesModalProps {
  pool: PoolDetailsResponse;
  showRulesModal: boolean;
  setShowRulesModal: CallableFunction;
}

const RulesModal = (props: RulesModalProps) => {

  const cardColor = useAppSelector(getCardColor);

  return (
    <Modal
      show={props.showRulesModal}
      onHide={() => {
        props.setShowRulesModal(false);
      }}
      size="lg"
    >
      <Modal.Body className={styles.modalBody} style={{ backgroundColor: cardColor }}>

        <button onClick={() => props.setShowRulesModal(false)}
                style={{ color: textColor }}
                className={styles.closeButton}>
          &times;
        </button>
        <BlockyBoldText style={{ color: textColor }}>
          {props.pool.event_name && `${props.pool.event_name}: `}{props.pool.name}
        </BlockyBoldText>

        <BlockyMediumText style={{ color: textColor, marginTop: "10px" }}>
          <span style={{ fontWeight: "bold" }}>Closes:</span> {dateFormatter(props.pool.close)}
        </BlockyMediumText>
        <BlockyMediumText style={{ color: textColor, marginTop: "10px", marginBottom: "20px" }}>
          <span style={{ fontWeight: "bold" }}>Win Condition:</span> {props.pool.win_condition}
        </BlockyMediumText>

        <BlockyBoldText style={{ color: textColor }}>Rules</BlockyBoldText>

        <div style={{ color: textColor, paddingTop: "20px" }}>{props.pool.rules}</div>
      </Modal.Body>
    </Modal>
  );
};

export default RulesModal;
